import React from 'react';
import type { PropsWithChildren } from 'react';

import './Page.sass';
import './LegacyHeight.sass';

import type { WithClassNameProp } from '@vlabs/uikit/types';
import classNames from 'classnames';

import type { WithLegacyProp } from './legacyProp';
import { PageProvider, usePageContext } from './usePageContext';

interface PageProps extends PropsWithChildren, WithClassNameProp, WithLegacyProp {}

function Page({
  children,
  legacy = false,
  className = undefined,
}: PageProps): React.JSX.Element {
  const { breakpoint } = usePageContext();
  return (
    <div
      className={classNames(
        'PageV2',
        `PageV2_breakpoint_${breakpoint}`,
        { 'legacy-height': legacy },
        className,
      )}
    >
      {children}
    </div>
  );
}

function PageWithProvider(props: PageProps): React.JSX.Element {
  return (
    <PageProvider>
      <Page {...props} />
    </PageProvider>
  );
}

export { PageWithProvider as Page };
